// extracted by mini-css-extract-plugin
export default {"dataBlock":"underwriting_dataBlock__ivekn","line":"underwriting_line__5qK2B"};